import classNames from 'classnames';
import React from 'react';

type Props = {
  id: string,
  color: string,
  active: boolean,
  
  onClick?: (event: React.SyntheticEvent) => void
};

class ColorButton extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, color, active, onClick } = this.props;

    return (
      <div className={classNames('esko_colorbuttonborder', {active: active})}>
        <div id={id} className='esko_colorbutton' onClick={onClick}>
          <div className={classNames('esko_colorsquare', 'esko_color_' + color)} />
        </div>
      </div>
    );
  }
}

export default ColorButton;
